var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { ofType, combineEpics } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import { loadedOperationChecks, loadingOperationChecks, loadedExperimentJournal, loadingExperimentJournal, loadedQualityAlerts, loadingQualityAlerts, resolvedQualityAlerts, loadQualityAlerts, toggleViewAndResolveAlerts, resolvingQualityAlerts } from "../ducks/AlertActions.js";
import AlertConstants from "../ducks/AlertConstants.js";
import AlertResources from "../resources/AlertResources.js";
import AlertUtils from "../utils/AlertUtils.js";
const loadOperationCheckEpic = (action$) => {
  return action$.pipe(
    ofType(AlertConstants.LOAD_OPERATION_CHECKS),
    mergeMap((value) => {
      const request = value;
      const loadOperationCheckObs = from(AlertResources.getOperationChecks(request.experimentId)).pipe(
        mergeMap((r) => {
          const opAlertResult = AlertUtils.parseOperationChecks(request.experimentId, r);
          return of(loadedOperationChecks(opAlertResult, request.uniqueAppModuleInstanceKey));
        }),
        catchError((error) => {
          return of(loadedOperationChecks(null, request.uniqueAppModuleInstanceKey, error.message));
        })
      );
      const loading = loadingOperationChecks(request.uniqueAppModuleInstanceKey);
      return from([loadOperationCheckObs, from([loading])]).pipe(mergeMap((x) => x));
    })
  );
};
const loadExperimentJournalEpic = (action$) => {
  return action$.pipe(
    ofType(AlertConstants.LOAD_EXPERIMENT_JOURNAL),
    mergeMap((value) => {
      const request = value;
      const loadExperimentJournalObs = from(AlertResources.getExperimentJournal(request.experimentId)).pipe(
        mergeMap((r) => {
          const expJournalResult = AlertUtils.parseExperimentJournal(request.experimentId, r);
          return of(loadedExperimentJournal(expJournalResult, request.uniqueAppModuleInstanceKey));
        })
        // catchError((error: Error) =>
        //   of(AlertActions.loadedAlertResolveReasons(null, request.uniqueAppModuleInstanceKey, error.message))
        // )
      );
      const loading = loadingExperimentJournal(request.uniqueAppModuleInstanceKey);
      return from([loadExperimentJournalObs, from([loading])]).pipe(mergeMap((x) => x));
    })
  );
};
const loadQualityAlertsEpic = (action$) => {
  return action$.pipe(
    ofType(AlertConstants.LOAD_QUALITY_ALERTS),
    mergeMap((value) => {
      const request = value;
      const loadQualityAlertObs = from(
        AlertResources.getActiveQualityAlertsVNext(request.experimentId, request.workspaceId)
      ).pipe(
        mergeMap((r) => {
          const qualityAlertEpicResult = AlertUtils.parseQualityAlertsVNext(r);
          return of(loadedQualityAlerts(qualityAlertEpicResult, request.uniqueAppModuleInstanceKey));
        }),
        catchError((error) => {
          return of(loadedQualityAlerts(null, request.uniqueAppModuleInstanceKey, error.message));
        })
      );
      const loading = loadingQualityAlerts(request.uniqueAppModuleInstanceKey);
      return from([loadQualityAlertObs, from([loading])]).pipe(mergeMap((x) => x));
    })
  );
};
const resolveQualityAlertsEpic = (action$) => {
  return action$.pipe(
    ofType(AlertConstants.RESOLVE_QUALITY_ALERTS),
    mergeMap((value) => {
      const actionRequest = value;
      const request = AlertUtils.createResolveAlertRequestDTO(actionRequest.alertEngageData);
      const action = !!actionRequest.alertEngageData.alertEngagement ? actionRequest.alertEngageData.alertEngagement.action || "Resolve" : "Resolve";
      const resolveQualityAlertObs = from(
        AlertResources.resolveQualityAlertsVNext(request, action, actionRequest.workspaceId)
      ).pipe(
        mergeMap((r) => {
          const engageResult = __spreadValues({}, r);
          return of(
            resolvedQualityAlerts(engageResult, actionRequest.uniqueAppModuleInstanceKey),
            loadQualityAlerts(
              actionRequest.experimentId,
              actionRequest.uniqueAppModuleInstanceKey,
              actionRequest.workspaceId
            ),
            toggleViewAndResolveAlerts(false, actionRequest.uniqueAppModuleInstanceKey)
          );
        })
      );
      const loading = resolvingQualityAlerts(actionRequest.uniqueAppModuleInstanceKey);
      return from([resolveQualityAlertObs, from([loading])]).pipe(mergeMap((x) => x));
    })
    // TODO
    // catchError((value: ILoadAlertAction) => of(loadedExperimentJournal(null, value.uniqueAppModuleInstanceKey)))
  );
};
const alertEpic = combineEpics(loadOperationCheckEpic, loadExperimentJournalEpic, loadQualityAlertsEpic, resolveQualityAlertsEpic);
export {
  alertEpic as default,
  loadExperimentJournalEpic,
  loadOperationCheckEpic,
  loadQualityAlertsEpic,
  resolveQualityAlertsEpic
};
//# sourceMappingURL=AlertEpic.js.map
